import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { backend } from "../../../../path";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Loader from "../../../layout/header/loader";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../../../components/whatsapp connect";
import LoaderMain from "../../../layout/header/loader_sub";
import styled from "styled-components";
import "./style.css";
function Registration() {
  const [loading, setLoading] = useState();
  const [formData, setFormData] = useState([]);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordStrength, setPasswordStrength] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  useEffect(() => {
    // Scroll to the top of the page whenever a new page is rendered
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = () => {
    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "password",
      "password_confirmation",
    ];
    const emptyFields = requiredFields.filter((field) => !formData[field]);

    if (emptyFields.length > 0) {
      toast.error("Please fill in all required fields", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Prevent further execution
    }

    // Email format validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(formData.email)) {
      toast.error("Please enter a valid email address", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Prevent further execution
    }

    // Password length validation
    if (formData.password.length < 6) {
      toast.error(
        "Weak Password Found, Try Another With Atleast 6 Characters Long",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return; // Prevent further execution
    }

    if (formData.password !== formData.password_confirmation) {
      toast.error("Password Unmatched, Try Again", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const agreeCheckbox = document.getElementById("agree-terms-and-policy");
    if (!agreeCheckbox.checked) {
      toast.error("Please agree to the terms & policies", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Prevent further execution
    }
    setLoading(true);

    const type = 1;
    formData.type = type;

    fetch(backend + "registration", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        setLoading(false);
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            setLoading(false);
            console.error("Email Already Exists");
            toast.error("Email Already Exists", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            setLoading(false);
            toast.error("Registration failed", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          setLoading(false);
          if (typeof window.openAuthModal === "function") {
            window.openAuthModal("login");
          } else {
            navigate("/login");
          }
          toast.success("Successfully Registered", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Registration failed", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  return (
    <>
      <div class="frame hidden lg:block">
        <div class="div">
          <div class="overlap-group-reg">
            <div class="text-wrapper-reg">Register</div>
            <img class="ks-reg" src="storage/general/ks-logo32-1.png" />
          </div>
          <p class="p">Please fill in the information below</p>
          <input
            className="div-wrapper-reg "
            name="name"
            id="txt-name"
            type="text"
            value={formData.first_name || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                first_name: e.target.value,
              })
            }
            placeholder="Your first name"
          />
          <input
            className="div-wrapper-2-reg "
            name="name"
            id="txt-name"
            type="text"
            value={formData.last_name || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                last_name: e.target.value,
              })
            }
            placeholder="Your last name"
          />
          <input
            className=" div-wrapper-3-reg"
            name="email"
            id="txt-email"
            type="email"
            value={formData.email || ""}
            onChange={(e) => {
              const email = e.target.value;
              setFormData({ ...formData, email });

              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(email)) {
                setEmailError("Invalid email format");
              } else {
                setEmailError("");
              }
            }}
            placeholder="Your email address"
          />

          <input
            className="div-wrapper-4-reg "
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password || ""}
            onChange={(e) => {
              const password = e.target.value;
              setFormData({ ...formData, password });

              // Update password strength state
              setPasswordStrength({
                length: password.length >= 6,
                uppercase: /[A-Z]/.test(password),
                lowercase: /[a-z]/.test(password),
                number: /\d/.test(password),
                specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
              });
            }}
            onPaste={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            placeholder="Your password"
          />

          <div
            className=" position-absolute password-toggle-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 512 512"
              >
                <path
                  fill="#3BB77E"
                  d="m63.998 86.005l21.998-21.998L447.999 426.01l-21.998 21.998zM259.34 192.09l60.57 60.57a64.07 64.07 0 0 0-60.57-60.57m-6.68 127.82l-60.57-60.57a64.07 64.07 0 0 0 60.57 60.57"
                ></path>
                <path
                  fill="#45B755"
                  d="M256 352a96 96 0 0 1-92.6-121.34l-69.07-69.08C66.12 187.42 39.24 221.14 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416A233.47 233.47 0 0 0 335 402.2l-53.61-53.6A95.84 95.84 0 0 1 256 352m0-192a96 96 0 0 1 92.6 121.34L419.26 352c29.15-26.25 56.07-61.56 76.74-96c-26.38-43.43-62.9-88.56-101.18-114.82C351.1 111.2 304.31 96 255.76 96a222.92 222.92 0 0 0-78.21 14.29l53.11 53.11A95.84 95.84 0 0 1 256 160"
                ></path>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 1024 1024"
              >
                <path
                  fill="#3BB77E"
                  d="M396 512a112 112 0 1 0 224 0a112 112 0 1 0-224 0m546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5M508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176s-78.8 176-176 176"
                ></path>
              </svg>
            )}
          </div>
          <input
            className="div-wrapper-5-reg "
            type={showPasswordConfirm ? "text" : "password"}
            name="password_confirmation"
            id="txt-password-confirmation"
            placeholder="Password confirmation"
            onChange={(e) =>
              setFormData({
                ...formData,
                password_confirmation: e.target.value,
              })
            }
            onPaste={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
          />

          <div
            className=" position-absolute passwordconfirm-toggle-icon"
            onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
          >
            {showPasswordConfirm ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 512 512"
              >
                <path
                  fill="#3BB77E"
                  d="m63.998 86.005l21.998-21.998L447.999 426.01l-21.998 21.998zM259.34 192.09l60.57 60.57a64.07 64.07 0 0 0-60.57-60.57m-6.68 127.82l-60.57-60.57a64.07 64.07 0 0 0 60.57 60.57"
                ></path>
                <path
                  fill="#45B755"
                  d="M256 352a96 96 0 0 1-92.6-121.34l-69.07-69.08C66.12 187.42 39.24 221.14 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416A233.47 233.47 0 0 0 335 402.2l-53.61-53.6A95.84 95.84 0 0 1 256 352m0-192a96 96 0 0 1 92.6 121.34L419.26 352c29.15-26.25 56.07-61.56 76.74-96c-26.38-43.43-62.9-88.56-101.18-114.82C351.1 111.2 304.31 96 255.76 96a222.92 222.92 0 0 0-78.21 14.29l53.11 53.11A95.84 95.84 0 0 1 256 160"
                ></path>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 1024 1024"
              >
                <path
                  fill="#3BB77E"
                  d="M396 512a112 112 0 1 0 224 0a112 112 0 1 0-224 0m546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5M508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176s-78.8 176-176 176"
                ></path>
              </svg>
            )}
          </div>
          <div className="div-wrapper-7-reg login_footer  ">
            <div className="chek-form">
              <div className="custome-checkbox">
                <input type="hidden" name="agree_terms_and_policy" value="0" />
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="agree_terms_and_policy"
                  id="agree-terms-and-policy"
                  value="1"
                />
                <label
                  className="form-check-label"
                  for="agree-terms-and-policy"
                >
                  <span>
                    <a href="/policy">I agree to the terms &amp; policies.</a>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="div-wrapper-6-reg cursor-pointer" onClick={handleSubmit}>
            <div class="text-wrapper-3-reg">Register</div>
          </div>
        </div>
        <div class="ks-wrapper-reg">
          <img class="ks-logo" src="storage/general/ks-logo32-1.png" />
        </div>
        <button
          type="button"
          command="close"
          commandfor="dialog"
          class="inline-flex"
        >
          <img
            class="material-symbols"
            src="storage/general/material-symbols-close.svg"
            command="close"
            commandfor="dialog"
          />
        </button>
      </div>
      <div class="flex block lg:hidden">
        <div class="w-full m-auto rounded p-4 relative">
          <header style={{ justifyItems: "anchor-center" }}>
            <button
              type="button"
              command="close"
              commandfor="dialog"
              class="absolute top-4 right-4 inline-flex"
            >
              <img
                class="material-symbols"
                src="storage/general/material-symbols-close.svg"
                command="close"
                commandfor="dialog"
              />
            </button>
            <img class="ks h-[100px]" src="storage/general/ks-logo32-1.png" />
            <p class="font-poppins font-bold text-[23px] leading-[100%] tracking-[0%] mt-4 text-[#000000]">
              Register
            </p>
            <p class="new-to-kerala mt-2">
              <span class="span font-[Poppins] font-medium text-[14px] leading-[100%] tracking-[0]">
                Please fill in the information below{" "}
              </span>{" "}
            </p>{" "}
          </header>
          {/* <form> */}
          <div>
            <div className="flex justify-between gap-2">
              <input
                name="name"
                id="txt-name"
                type="text"
                value={formData.first_name || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    first_name: e.target.value,
                  })
                }
                placeholder="Your first name"
                class="w-[49%] h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
              />
              <input
                name="name"
                id="txt-name"
                type="text"
                value={formData.last_name || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    last_name: e.target.value,
                  })
                }
                placeholder="Your last name"
                class="w-[49%] h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
              />
            </div>
            <input
              name="email"
              id="txt-email"
              type="email"
              value={formData.email || ""}
              onChange={(e) => {
                const email = e.target.value;
                setFormData({ ...formData, email });

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                  setEmailError("Invalid email format");
                } else {
                  setEmailError("");
                }
              }}
              placeholder="Your email address"
              class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
            />
            <input
              name="password"
              type="password"
              value={formData.password || ""}
              onChange={(e) => {
                const password = e.target.value;
                setFormData({ ...formData, password });

                // Update password strength state
                setPasswordStrength({
                  length: password.length >= 6,
                  uppercase: /[A-Z]/.test(password),
                  lowercase: /[a-z]/.test(password),
                  number: /\d/.test(password),
                  specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
                });
              }}
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              placeholder="Your password"
              class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
            />
            <input
              name="password_confirmation"
              id="txt-password-confirmation"
              placeholder="Password confirmation"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  password_confirmation: e.target.value,
                })
              }
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
            />
            <div class="h-[20px]">
              <input
                className="form-check-input mr-3"
                type="checkbox"
                name="agree_terms_and_policy"
                id="agree-terms-and-policy"
                value="1"
              />
              <label className="form-check-label" for="agree-terms-and-policy">
                <span>
                  <a href="/policy">I agree to the terms &amp; policies.</a>
                </span>
              </label>
            </div>
          </div>

          <div
            class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-[#62BC01] my-3 justify-center"
            onClick={handleSubmit}
            style={{ justifyItems: "anchor-center" }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div class="font-[Poppins] font-medium text-[16px] leading-[100%] tracking-[0] text-white">
              Register
            </div>
          </div>

          <div
            class="w-full h-[44px] opacity-100 rounded-lg border pt-[3px] pl-[17px] bg-[#fff] my-3 justify-center items-center"
            // onClick={handleSubmit}
            // style={{ justifyItems: "anchor-center" }}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     handleSubmit();
            //   }
            // }}
          >
            {/* <div class="font-[Poppins] font-medium text-[16px] leading-[100%] tracking-[0] text-[#000] flex justify-center items-center">
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-5"
              >
                <path
                  d="M29.9826 13.8071H28.875V13.75H16.5V19.25H24.2708C23.1371 22.4517 20.0908 24.75 16.5 24.75C11.9439 24.75 8.25 21.0561 8.25 16.5C8.25 11.9439 11.9439 8.25 16.5 8.25C18.6031 8.25 20.5164 9.04338 21.9732 10.3393L25.8624 6.45013C23.4066 4.16144 20.1218 2.75 16.5 2.75C8.90656 2.75 2.75 8.90656 2.75 16.5C2.75 24.0934 8.90656 30.25 16.5 30.25C24.0934 30.25 30.25 24.0934 30.25 16.5C30.25 15.5781 30.1551 14.6781 29.9826 13.8071Z"
                  fill="#FFC107"
                />
                <path
                  d="M4.33594 10.1001L8.8535 13.4131C10.0759 10.3867 13.0363 8.25 16.5006 8.25C18.6036 8.25 20.5169 9.04337 21.9738 10.3393L25.8629 6.45012C23.4072 4.16144 20.1223 2.75 16.5006 2.75C11.2192 2.75 6.63906 5.73169 4.33594 10.1001Z"
                  fill="#FF3D00"
                />
                <path
                  d="M16.5007 30.25C20.0523 30.25 23.2795 28.8908 25.7194 26.6805L21.4638 23.0794C20.0371 24.165 18.2934 24.7519 16.5007 24.75C12.9243 24.75 9.88764 22.4695 8.74364 19.2871L4.25977 22.7418C6.53539 27.1947 11.1568 30.25 16.5007 30.25Z"
                  fill="#4CAF50"
                />
                <path
                  d="M29.9826 13.8071H28.875V13.75H16.5V19.25H24.2708C23.7285 20.7738 22.7517 22.1053 21.461 23.0801L21.4631 23.0787L25.7187 26.6798C25.4176 26.9534 30.25 23.375 30.25 16.5C30.25 15.5781 30.1551 14.6781 29.9826 13.8071Z"
                  fill="#1976D2"
                />
              </svg>
              Continue with Google
            </div> */}
          </div>

          <div></div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Registration;
const Main = styled.main`
  form {
    display: grid;
    gap: 10px;
  }
  input {
    margin: 10px 0;
    padding: 10px;
  }
`;
